const PercentagesBar = ({ activeTime, totalTime }) => {
  const inactiveColor = "#EAF7F5"; // Gris para el resto del porcentaje

  // Colores según especificaciones de María y Juan
  const redColor = "#F9839A";      // Rojo fuerte para < 60%
  const yellowColor = "#F4D947";   // Amarillo fuerte para 60-79%
  const greenColor = "#2AAC9C";    // Verde fuerte para 80-100%

  const activePercent = totalTime > 0 ? (activeTime / totalTime) * 100 : 0;
  const inactivePercent = 100 - activePercent;

  let activeColor;
  let activeTextColor;
  if (activePercent >= 80) {
    activeColor = greenColor;
    activeTextColor = "white";
  } else if (activePercent >= 60) {
    activeColor = yellowColor;
    activeTextColor = "black";
  } else {
    activeColor = redColor;
    activeTextColor = "white";
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        borderRadius: "4px",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Active section */}
      <div
        style={{
          height: "24px",
          width: `${activePercent}%`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: activeTextColor,
          fontWeight: "600",
          fontSize: "12px",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "24px",
            backgroundColor: activeColor,
            borderRadius: "4px 0 0 4px",
          }}
        ></div>
        <div style={{ position: "absolute", zIndex: 1 }}>{Math.round(activePercent)}%</div>
      </div>

      {/* Inactive section */}
      <div
        style={{
          height: "24px",
          width: `${inactivePercent}%`,
          backgroundColor: inactiveColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#228C80",
          fontWeight: "600",
          fontSize: "12px",
          borderRadius: "0 4px 4px 0",
        }}
      >
        {Math.round(inactivePercent)}%
      </div>
    </div>
  );
};

export default PercentagesBar;
